import DataRow from '@/modules/Workspaces/KnowledgeHub/Hubs/FileTable/DataRow.vue'
import Header from '@/modules/Workspaces/KnowledgeHub/Hubs/FileTable/Header.vue'

export const HubTable = {
  DataRow,
  Header,
}
